import {
  ElementPropertyImmutableType,
  ElementPropertyLinkType,
  ElementPropertyTargetType,
  ElementPropertyTypeSchema,
  nullishToOptional,
} from "@supernova-studio/model";
import { z } from "zod";
import { DTOColorTokenInlineData } from "../../aux";
import { DTOObjectMeta } from "../../aux/meta";

const CODE_NAME_REGEX = /^[a-zA-Z_$][a-zA-Z_$0-9-]{1,99}$/;

export const DTOElementPropertyDefinitionOption = z.object({
  id: z.string(),
  name: z.string(),
  backgroundColor: DTOColorTokenInlineData.optional(),
});

// DTO Object
export const DTOElementPropertyDefinition = z.object({
  id: z.string(),
  designSystemVersionId: z.string(),
  meta: DTOObjectMeta,
  persistentId: z.string(),
  type: ElementPropertyTypeSchema,
  targetElementType: ElementPropertyTargetType,
  codeName: z.string().regex(CODE_NAME_REGEX),
  options: nullishToOptional(z.array(DTOElementPropertyDefinitionOption)),
  linkElementType: nullishToOptional(ElementPropertyLinkType),
  isImmutable: z.boolean(),
  immutablePropertyType: ElementPropertyImmutableType.optional(),
});

export type DTOElementPropertyDefinitionOption = z.infer<typeof DTOElementPropertyDefinitionOption>;
export type DTOElementPropertyDefinition = z.infer<typeof DTOElementPropertyDefinition>;

//
// Read
//

export const DTOElementPropertyDefinitionListResponse = z.object({
  definitions: z.array(DTOElementPropertyDefinition),
});

export const DTOElementPropertyDefinitionResponse = z.object({
  definition: DTOElementPropertyDefinition,
});

export type DTOElementPropertyDefinitionListResponse = z.infer<typeof DTOElementPropertyDefinitionListResponse>;
export type DTOElementPropertyDefinitionResponse = z.infer<typeof DTOElementPropertyDefinitionResponse>;

//
// Write
//

export const DTOElementPropertyDefinitionCreatePayload = z.object({
  meta: DTOObjectMeta,
  persistentId: z.string(),
  type: ElementPropertyTypeSchema,
  targetElementType: ElementPropertyTargetType,
  codeName: z.string().regex(CODE_NAME_REGEX),
  options: nullishToOptional(z.array(DTOElementPropertyDefinitionOption)),
  linkElementType: nullishToOptional(ElementPropertyLinkType),
  columnWidth: z.number().max(1024).optional(),
});

export const DTOElementPropertyDefinitionUpdatePayload = z.object({
  meta: DTOObjectMeta.optional(),
  codeName: z.string().regex(CODE_NAME_REGEX).optional(),
  options: z.array(DTOElementPropertyDefinitionOption).optional(),
});

export type DTOElementPropertyDefinitionCreatePayload = z.infer<typeof DTOElementPropertyDefinitionCreatePayload>;
export type DTOElementPropertyDefinitionUpdatePayload = z.infer<typeof DTOElementPropertyDefinitionUpdatePayload>;
